import { StatusIcon } from "./StatusIcon";

// The server's evidence notes on the basis of a result (Master Prompt A38 (d), A43 D6): fixed
// sentences such as the IR-009 note every fault study carries, on what its voltage factor c and
// peak factor kappa are verified against, and the note on a run of an earlier fault engine. Shown
// as received, in the review tone, on the study page and on the report sheet alike; there is no
// way to dismiss a note. Nothing is rendered when the result has none.

type EvidenceNotesPanelProps = {
  notes: readonly string[];
  // On the report sheet the panel is one of the sheet's sections.
  reportSection?: boolean;
};

export function EvidenceNotesPanel({ notes, reportSection = false }: EvidenceNotesPanelProps) {
  if (notes.length === 0) {
    return null;
  }
  return (
    <section
      aria-label="Evidence notes"
      data-evidence-notes
      data-report-section={reportSection ? "evidence-notes" : undefined}
    >
      <h3>Evidence notes</h3>
      <ul data-note-count={notes.length}>
        {notes.map((note, index) => (
          <li key={`${index}-${note}`} data-evidence-note>
            <StatusIcon tone="review" size={16} />
            <span>{note}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default EvidenceNotesPanel;
